// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import type { EnvironmentBrand } from './environment-brand';

export const environment = {
  /** Optional white-label auth / shell branding (see environment.ludafit.ts). */
  brand: undefined as EnvironmentBrand | undefined,
  baseUrl: "http://localhost:8100/",
  production: false,
  /** Meta Pixel ID for lander; null disables pixel in dev */
  metaPixelId: null as string | null,
  stripeKey: 'pk_test_wN2e5J039WBYN0NytUscbcVy',
  sentryKey: '',
  supportUserId: "9wLh7PpECuho7s69JNCXaxriysn2",
  /** App Store / Play review contact (Elite Trainr dev account). */
  whiteLabelAppReviewContactEmail: 'info@elitetrainr.com',
  whiteLabel: {
    setupFeeUsd: 199,
    subscriptionAmountUsd: 299,
    subscriptionIntervalMonths: 6,
  },
  //apiUrl: "http://127.0.0.1:5001/elite-trainr-dev-ddb35/us-central1/api",
  apiUrl: "https://us-central1-elite-trainr-dev-ddb35.cloudfunctions.net/api",
  algolia: {
    foods: "foods_elitetrainr",
    foodCounter: "foods_counter_elitetrainr",
    exercises: "exercises_elitetrainr",
    exerciseCounter: "exercises_counter_elitetrainr",
    users: "users_elitetrainr",
  },
  firebaseConfig: {
    apiKey: "AIzaSyDTPQhbJz3VHizxSdTi2D3M1GFIEN1AYvs",
    authDomain: "elite-trainr-dev-ddb35.firebaseapp.com",
    databaseURL: "https://elite-trainr-dev-ddb35.firebaseio.com",
    projectId: "elite-trainr-dev-ddb35",
    storageBucket: "elite-trainr-dev-ddb35.appspot.com",
    messagingSenderId: "1073625843750"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
